<app-file-upload
  [label]="label"
  [accept]="accept || 'image/*'"
  [multiple]="false"
  [text]="'Trascina o premi qui per caricare l\'immagine'"
  (load)="onFileLoad($event)">
</app-file-upload>

@if (immagineFile) {
  <div class="mx-auto lg:w-1/2 w-full my-4 h-full">
    <image-cropper
      [imageFile]="immagineFile"
      [aspectRatio]="aspect_ratio"
      [resizeToHeight]="resize_height"
      [cropperMinWidth]="width"
      [cropperMinHeight]="height"
      format="jpeg"
      [onlyScaleDown]="true"
      (imageCropped)="cropImg($event)">
    </image-cropper>
  </div>
}
